import {GoDotFill} from "react-icons/go";
import useTranslate from "../../modules/local/useTranslate";
import classNames from "classnames";
import React from "react";
import {renderIf, renderIfElse} from "../../views/Shared";


export const DoubleValueItem = ({
                                    showIcon = false,
                                    primary = false,
                                    style,
                                    className = 'text-sm',
                                    iconFirst,
                                    labelFirst,
                                    valueFirst,
                                    iconSecond,
                                    labelSecond,
                                    valueSecond,
                                }) => {
    const t = useTranslate()

    return (
        <div style={style} className={classNames("space-x-1", className)}>
            {renderIf(
                showIcon === true,
                <GoDotFill size={className ? 10 : 12} className="text-color-400"/>
            )}
            {renderIfElse(
                labelFirst,
                <span className="text-color-400 italic whitespace-no-wrap">
                    {`${t(labelFirst)}: `}
                </span>,
                iconFirst
            )}
            <span
                className={primary === true ? 'font-bold text-gray-800' : valueFirst ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
                {valueFirst || t('not update')}
            </span>
            {renderIfElse(
                labelSecond,
                <span
                    className="mx-1 text-color-400 italic whitespace-no-wrap">{t(labelSecond) || ''}</span>,
                iconSecond
            )}
            {renderIf(
                valueSecond,
                <span
                    className={primary === true ? 'font-bold text-gray-800' : valueSecond ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
                    {valueSecond || t('not update')}
                </span>
            )}
        </div>
    )
}
